import * as React from "react";
function MagnifyingGlassFillIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "50px"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.63 9.81a7.82 7.82 0 0 1-15.64.02A7.82 7.82 0 0 1 9.82 2a7.82 7.82 0 0 1 7.81 7.81M16 17.43C11.794 20.846 5.616 20.206 2.2 16-1.215 11.794-.575 5.616 3.63 2.2A9.81 9.81 0 0 1 17.43 16l6.28 6.28a1.004 1.004 0 0 1-1.42 1.42z"
  }));
}
export default MagnifyingGlassFillIcon;